/* DON'T EDIT THIS FILE: edit original and run build again */ export const sleep = (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));
